import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormControlError, FormField, FormValidators } from '../../components/form-builder/model/form-field';
import { GET_TOTAL_MODULES } from '../../app/service/module.service';
import { LOOK_UP_DATA } from '../../app/service/lookup.service';
import { CREATE_INDIVIDUAL_STUDENT, GET_USER_BY_ID, VALIDATE_USER_NAME } from '../../app/service/users.service';
import { FormValidator, GetControlIsValid } from '../../components/form-builder/validations';
import FormBuilder from '../../components/form-builder';
import errorMessages from '../../components/error-messages';
import appConfig from '../../config/constant';
import { UPLOAD_LOGO } from '../../app/service/school.service';
import Logos from "../../assets/images/eliments.svg";
import LogoImg from '../../assets/images/iamsamarth-Logo-Final.svg';
import { DateComponent } from '../../components/date';

export const IndividualUserForm = () => {
    const [studentsData, setStudentsData] = useState<any>({});
    const [formData, setFormData] = useState<any>({});
    const [validationErrors, setValidationErrors] = useState<FormControlError[]>([]);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [currentStudentData, setCurrentStudentData] = useState<any>({});
    const [statesData, setStatesData] = useState<any>([]);
    const [districtData, setDistrictData] = useState<any>([]);
    const [cityData, setCityData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [canShowUserPopup, setCanShowUserPopup] = useState(false);
    const [mobileNumber, setMobileNumber] = useState(false);
    const [confirmMobileNumber, setConfirmMobileNumber] = useState(false);
    const [motherMobileNumber, setMotherMobileNumber] = useState(false);
    const [fathermobileNumber, setFatherMobileNumber] = useState(false);
    const [motherwhatsappNumber, setMotherWhatsappNumber] = useState(false);
    const [fatherwhatsappNumber, setFatherWhatsappNumber] = useState(false);
    const [pincodeNumber, setPincodeNumber] = useState(false);
    const [studentInfo, setStudentInfo] = useState<any>({});
    const [min, setMin] = useState<any>(moment().subtract(60, "years").format("YYYY-MM-DD"));
    const [max, setMax] = useState<any>(moment().subtract(10, "years").format("YYYY-MM-DD"));
    const [canCheckMotherMobileNumber, setCanCheckMotherMobileNumber] = useState(false);
    const [canCheckFatherMobileNumber, setCanCheckFatherMobileNumber] = useState(false);
    const [canShowMotherWhatsAppError, setCanShowMotherWhatsAppError] = useState(false);
    const [canShowFatherWhatsAppError, setCanShowFatherWhatsAppError] = useState(false);
    const [email, setEmail] = useState(false);
    const [confirmEmail, confirmSetEmail] = useState(false);
    const [motherEmail, setMotherEmail] = useState(false);
    const [fatherEmail, setFatherEmail] = useState(false);
    const [canSelectedDateofBirth, setCanSelectedDateofBirth] = useState(false);
    const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD'));
    const [startDate, setStartDate] = useState(null);
    const [createDate, setCreateDate] = useState(new Date());
    const dates = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    const month = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const [years, setYears] = useState<any>([]);
    const [canShowDate, setCanShowDate] = useState<any>();
    const [canShowMonth, setCanShowMonth] = useState<any>();
    const [canShowYear, setCanShowYear] = useState<any>();
    const [isRegistrationDateError, setIsRegistrationDateError] = useState<any>({});

    let { id } = useParams<{ id: string }>();
    const usersId: number = parseInt(id);
    const [isDateError, setIsDateError] = useState<any>({});
    const [nameError, setNameError] = useState('');
    const [addressOne, setAddressOneError] = useState('');
    const [addressTwo, setAddressTwoError] = useState('');
    const [motherNameError, setMotherNameError] = useState('');
    const [motherOccupationError, setMotherOccupationError] = useState('');
    const [fatherNameError, setFatherNameError] = useState('');
    const [fatherOccupationError, setFatherOccupationError] = useState('');
    const [schoolNameError, setSchoolError] = useState('');
    const [schoolAddressError, setSchoolAddressError] = useState('');
    const [schoolAddressTwoError, setSchoolAddressTwoError] = useState('');

    const [userNameError, setUserNameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [avalableUserNames, setAvalableUserNames] = useState([]);



    const history = useHistory();

    const formValidations = [
        new FormField('name', [FormValidators.REQUIRED]),
        new FormField('gender', [FormValidators.REQUIRED]),
        new FormField('date_of_birth', []),
        new FormField('standard', [FormValidators.REQUIRED]),
        new FormField('email_id', [FormValidators.REQUIRED]),
        new FormField('confirm_student_email_id', [FormValidators.REQUIRED]),
        new FormField('mobile_number', [FormValidators.REQUIRED]),
        new FormField('confirm_student_mobile_number', [FormValidators.REQUIRED]),
        new FormField('address', [FormValidators.REQUIRED]),
        new FormField('address2', []),
        new FormField('state', [FormValidators.REQUIRED]),
        new FormField('district', [FormValidators.REQUIRED]),
        new FormField('pin_code', [FormValidators.REQUIRED]),
        new FormField('mother_name', [FormValidators.REQUIRED]),
        new FormField('mother_occupation', [FormValidators.REQUIRED]),
        new FormField('mother_mobile', [FormValidators.REQUIRED]),
        new FormField('mother_whatsapp', []),
        new FormField('mother_email_id', [FormValidators.REQUIRED]),
        new FormField('father_name', [FormValidators.REQUIRED]),
        new FormField('father_occupation', [FormValidators.REQUIRED]),
        new FormField('father_mobile', [FormValidators.REQUIRED]),
        new FormField('father_whatsapp', []),
        new FormField('father_email_id', [FormValidators.REQUIRED]),
        new FormField('institute_school_code', [FormValidators.REQUIRED]),
        new FormField('school_board', [FormValidators.REQUIRED]),
        new FormField('school_state', [FormValidators.REQUIRED]),
        new FormField('school_district', [FormValidators.REQUIRED]),
        new FormField('school_pincode', [FormValidators.REQUIRED]),
        new FormField('school_address', [FormValidators.REQUIRED]),
        new FormField('school_address2', []),
        new FormField('blood_group', []),

    ];


    useEffect(() => {
        const now = new Date().getUTCFullYear();
        let yearStart = now - 10;
        const years = Array(yearStart - (yearStart - 60)).fill('').map((v, idx) => yearStart - idx);
        setYears(years);

        setLoading(true);
        LOOK_UP_DATA().then((data1: any) => {
            if (data1.status === 'fail') {
                toast.error(data1.message);
                setLoading(false);
            } else {
                setLoading(false);
                setStatesData(data1.states);
            }
        });
    }, []);


    const handleInput = (data: any) => {
        data.value = { ...currentStudentData, ...data.value };
        setStudentsData(data);
        const errors: any = FormValidator(formValidations, data.value);
        setValidationErrors(errors);
    };

    const checkAvalableNames = () => {
        const data = studentsData.value ? { ...studentsData.value } : { ...currentStudentData };
        data.date_of_birth = startDate ? moment(startDate).format('YYYY-MM-DD') : null;

        const validUser = {
            user_name: data.user_name,
            name: data.name,
            dob: data.date_of_birth
        }
        if (onChangeName(data.name) && data.date_of_birth && onChangeUserName(data.user_name)) {
            VALIDATE_USER_NAME(validUser).then((userValidData: any) => {
                if (!userValidData?.available) {
                    setAvalableUserNames(userValidData.ref_user_name)
                }
            })
        } else {
            if (!nameError && !onChangeName(data.name)) {
                setNameError('Please enter student name');
            }
            if (!userNameError && !onChangeUserName(data.user_name)) {
                setUserNameError('Please enter user name');
            }
            if (!data.date_of_birth) {
                setIsDateError({ error: "please select date of birth" });
            }
        }

    }
    const handleSubmit = () => {
        setIsFormSubmitted(true);
        const data = studentsData.value ? { ...studentsData.value } : { ...currentStudentData };
        data.date_of_birth = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        setCanSelectedDateofBirth(false);
        const errors: FormControlError[] = FormValidator(formValidations, data);
        setValidationErrors(errors);
        data.user_role = "STUDENT";
        data.indv_school_details = {
            school_name: data.institute_school_code,
            school_board: data.school_board,
            school_address: data.school_address,
            school_address2: data.school_address2 ? data.school_address2 : '',
            state: data.school_state,
            district: data.school_district,
            pin_code: data.school_pincode
        }
        delete data.sameMobileNumber;
        delete data.checkedMother;
        delete data.checkedFather;
        delete data.checked;
        delete data.school_board;
        delete data.school_address;
        delete data.school_state;
        delete data.school_district;
        delete data.school_pincode;
        delete data.day;
        delete data.month;
        delete data.year;
        delete data.school_address2;
        if (data.date_of_birth) {
            setCanSelectedDateofBirth(false);
        } else {
            setCanSelectedDateofBirth(true);
        }

        if ((data.email_id == data.confirm_student_email_id) && (data.mobile_number == data.confirm_student_mobile_number)) {

            if (errors.length < 1 && !canSelectedDateofBirth && !email && !mobileNumber && !motherMobileNumber && !fathermobileNumber && !pincodeNumber
                && onChangeName(data.name)
                && onChangeAddressOne(data.address)
                && onChangeAddressTwo(data.address2)
                && onChangeMotherName(data.mother_name)
                && onChangeMotherOccupation(data.mother_occupation)
                && onChangeFatherName(data.father_name)
                && onChangeFatherOccupation(data.father_occupation)
                && onChangeSchoolName(data.institute_school_code)
                && onChangeSchoolAddress(data?.indv_school_details?.school_address)
                && onChangeUserName(data.user_name)
                && onChangePassword(data.password)
            ) {
                data.mother_whatsapp = data.mother_whatsapp ? data.mother_whatsapp : data.mother_mobile;
                data.father_whatsapp = data.father_whatsapp ? data.father_whatsapp : data.father_mobile;
                setLoading(true);
                delete data.confirm_student_email_id;
                delete data.confirm_student_mobile_number;

                CREATE_INDIVIDUAL_STUDENT(data).then((res: any) => {
                    if (res.status === 'fail' || res.errorCode === 400) {
                        toast.error(res.message || res.errorMsg);
                        setLoading(false);
                        data.school_board = data.indv_school_details.school_board;
                        data.school_address = data.indv_school_details.school_address;
                        data.school_state = data.indv_school_details.state;
                        data.school_district = data.indv_school_details.district;
                        data.school_pincode = data.indv_school_details.pin_code;
                        data.confirm_student_email_id = data.email_id;
                        data.confirm_student_mobile_number = data.mobile_number;
                        setCurrentStudentData(data);
                    } else {
                        toast.success("Students Created Successfully");
                        setLoading(false);
                        setStudentInfo(res);
                        setCanShowUserPopup(true);
                    }
                });
            }

            else {

                if (!nameError && !onChangeName(data.name)) {
                    setNameError('Please enter student name');
                }
                if (!addressOne && !onChangeAddressOne(data.address)) {
                    setAddressOneError('Please enter address line 1');
                }
                if (!addressTwo && !onChangeAddressTwo(data.address2)) {
                    setAddressTwoError('Please enter address line 2');
                }
                if (!motherNameError && !onChangeMotherName(data.mother_name)) {
                    setMotherNameError('Please enter mother\'s Name');
                }
                if (!motherOccupationError && !onChangeMotherOccupation(data.mother_occupation)) {
                    setMotherOccupationError('Please enter mother\'s occupation');
                }
                if (!fatherNameError && !onChangeFatherName(data.father_name)) {
                    setFatherNameError('Please enter father\'s name');
                }
                if (!fatherOccupationError && !onChangeFatherOccupation(data.father_occupation)) {
                    setFatherOccupationError('Please enter father\'s occupation');
                }
                if (!schoolNameError && !onChangeSchoolName(data.institute_school_code)) {
                    setSchoolError('Please enter school name');
                }
                if (!schoolAddressError && !onChangeSchoolAddress(data?.indv_school_details?.school_address)) {
                    setSchoolAddressError('Please enter school address');
                }

                if (!userNameError && !onChangeUserName(data.user_name)) {
                    setUserNameError('Please enter user name');
                }
                if (!passwordError && !onChangePassword(data.password)) {
                    setPasswordError('Please enter password');
                }
            }
        } else {
            setCurrentStudentData(data);
            toast.error("confirm email and mobile number not matching");
        }


    }

    const getInputValid = (control: string) => {
        const value = GetControlIsValid(validationErrors, control);
        return value;
    }

    const handleStateChange = (e: any) => {
        const data = { ...studentsData.value };
        data.state = e.target.value;
        const preparedData = statesData.filter((el: any) => el.state === e.target.value);
        setDistrictData(preparedData[0].districts);
        setCityData(preparedData[0].cities);
        if (currentStudentData) {
            currentStudentData.state = e.target.value;
        }
    }

    const handleSchoolStateChange = (e: any) => {
        const data = { ...studentsData.value };
        data.school_state = e.target.value;
        const preparedData = statesData.filter((el: any) => el.state === e.target.value);
        setDistrictData(preparedData[0].districts);
        setCityData(preparedData[0].cities);
        if (currentStudentData) {
            currentStudentData.school_state = e.target.value;
        }
    }

    const handleDistrictChange = (e: any) => {
        const data = { ...studentsData.value };
        data.district = e.target.value;
        if (currentStudentData) {
            currentStudentData.district = e.target.value;
        }
    }

    const handleSchoolDistrictChange = (e: any) => {
        const data = { ...studentsData.value };
        data.school_district = e.target.value;
        if (currentStudentData) {
            currentStudentData.school_district = e.target.value;
        }
    }

    const handleSchoolBoardChange = (e: any) => {
        const data = { ...studentsData.value };
        data.school_board = e.target.value;
        if (currentStudentData) {
            currentStudentData.school_board = e.target.value;
        }
    }

    const handleGender = (e: any) => {
        const data = { ...studentsData.value };
        data.gender = e.target.value;
        if (currentStudentData) {
            currentStudentData.gender = e.target.value;
        }
    }

    const handleUserName = (e: any) => {
        const data = { ...studentsData.value };
        data.user_name = e.target.value;
        if (currentStudentData) {
            currentStudentData.user_name = e.target.value;
        }
    }


    const handleUserclose = () => {
        setCanShowUserPopup(false);
        history.push(`/`);
    }

    const handleStandardChange = (e: any) => {
        const data = { ...studentsData.value };
        data.standard = e.target.value;
        if (currentStudentData) {
            currentStudentData.standard = e.target.value;
        }
    }

    const handleMobileChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /(6|7|8|9)\d{9}/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 10) {
            data.mobile_number = e.target.value;
            setMobileNumber(false);
        } else {
            data.mobile_number = e.target.value;
            setMobileNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.mobile_number = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleConfirmMobileChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /(6|7|8|9)\d{9}/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 10) {
            data.confirm_student_mobile_number = e.target.value;
            setConfirmMobileNumber(false);
        } else {
            data.confirm_student_mobile_number = e.target.value;
            setConfirmMobileNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.confirm_student_mobile_number = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleMothesMobileChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /(6|7|8|9)\d{9}/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 10) {
            data.mother_mobile = e.target.value;
            setMotherMobileNumber(false);
        } else {
            data.mother_mobile = e.target.value;
            setMotherMobileNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.mother_mobile = e.target.value.replace(/\D+/g, '');
        }

        if (currentStudentData.checkedMother) {
            currentStudentData.mother_whatsapp = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleFatherMobileChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /(6|7|8|9)\d{9}/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 10) {
            data.father_mobile = e.target.value;
            setFatherMobileNumber(false);
        } else {
            data.father_mobile = e.target.value;
            setFatherMobileNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.father_mobile = e.target.value.replace(/\D+/g, '');
        }

        if (currentStudentData.checkedFather) {
            currentStudentData.father_whatsapp = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleMotherWhatsappChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /(6|7|8|9)\d{9}/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 10) {
            data.mother_whatsapp = e.target.value;
            setMotherWhatsappNumber(false);
            setCanShowMotherWhatsAppError(false);
        } else {
            data.mother_whatsapp = e.target.value;
            setMotherWhatsappNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.mother_whatsapp = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleFatherWhatsappChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /(6|7|8|9)\d{9}/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 10) {
            data.father_whatsapp = e.target.value;
            setFatherWhatsappNumber(false);
            setCanShowFatherWhatsAppError(false);
        } else {
            data.father_whatsapp = e.target.value;
            setFatherWhatsappNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.father_whatsapp = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleEmailChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;


        if (e.target.value === '' || re.test(e.target.value)) {
            data.email_id = e.target.value;
            setEmail(false);
        } else {
            data.email_id = e.target.value;
            setEmail(true);
        }

        if (currentStudentData) {
            currentStudentData.email_id = e.target.value;
        }
    }

    const handleConfirmEmailChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;


        if (e.target.value === '' || re.test(e.target.value)) {
            data.confirm_student_email_id = e.target.value;
            confirmSetEmail(false);
        } else {
            data.confirm_student_email_id = e.target.value;
            confirmSetEmail(true);
        }

        if (currentStudentData) {
            currentStudentData.confirm_student_email_id = e.target.value;
        }
    }

    const handleMotherEmailChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;


        if (e.target.value === '' || re.test(e.target.value)) {
            data.mother_email_id = e.target.value;
            setMotherEmail(false);
        } else {
            data.mother_email_id = e.target.value;
            setMotherEmail(true);
        }

        if (currentStudentData) {
            currentStudentData.mother_email_id = e.target.value;
        }
    }

    const handleFatherEmailChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/;


        if (e.target.value === '' || re.test(e.target.value)) {
            data.father_email_id = e.target.value;
            setFatherEmail(false);
        } else {
            data.father_email_id = e.target.value;
            setFatherEmail(true);
        }

        if (currentStudentData) {
            currentStudentData.father_email_id = e.target.value;
        }
    }

    const handlePinCodeChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /^[0-9\b]+$/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 6) {
            data.pin_code = e.target.value;
            setPincodeNumber(false);
        } else {
            data.pin_code = e.target.value;
            setPincodeNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.pin_code = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleSchoolPinCodeChange = (e: any) => {
        const data = { ...studentsData.value };
        const re = /^[0-9\b]+$/;

        if ((e.target.value === '' || re.test(e.target.value)) && e.target.value.length === 6) {
            data.school_pincode = e.target.value;
            setPincodeNumber(false);
        } else {
            data.school_pincode = e.target.value;
            setPincodeNumber(true);
        }

        if (currentStudentData) {
            currentStudentData.school_pincode = e.target.value.replace(/\D+/g, '');
        }
    }

    const handleMotherMobileNumberChange = (e: any) => {
        const data = { ...studentsData.value };
        if (e.target.checked) {
            if (data.mother_whatsapp) {
                data.mother_whatsapp = data.mother_mobile;
                currentStudentData.mother_whatsapp = data.mother_mobile;
                setCanCheckMotherMobileNumber(true);
                setCanShowMotherWhatsAppError(false);
            }
            if (data.mother_mobile || currentStudentData.mother_mobile) {
                setCanCheckMotherMobileNumber(true);
                setCanShowMotherWhatsAppError(false);
                currentStudentData.mother_whatsapp = currentStudentData.mother_mobile;
                setCurrentStudentData(currentStudentData);
            }
            currentStudentData.checkedMother = true;
        } else {

            setCanCheckMotherMobileNumber(false);
            currentStudentData.checkedMother = false;
        }
    }

    const handleFatherMobileNumberChange = (e: any) => {
        const data = { ...studentsData.value };
        if (e.target.checked) {
            if (data.father_whatsapp) {
                data.father_whatsapp = data.father_mobile;
                currentStudentData.father_whatsapp = data.father_whatsapp;
                setCanCheckFatherMobileNumber(true);
                setCanShowFatherWhatsAppError(false);
            }
            if (data.father_mobile || currentStudentData.father_mobile) {
                setCanCheckFatherMobileNumber(true);
                setCanShowFatherWhatsAppError(false);
                currentStudentData.father_whatsapp = currentStudentData.father_mobile;
                setCurrentStudentData(currentStudentData);
            }
            currentStudentData.checkedFather = true;
        } else {

            setCanCheckFatherMobileNumber(false);
            currentStudentData.checkedFather = false;
        }
    }

    const onChange = (dates: any) => {
        setStartDate(null);
        if (dates.error) {
            setIsDateError(dates);
        } else {
            setStartDate(dates.date);
        }
    };

    const onDateChange = (dates: any) => {
        setTodayDate(todayDate);
        if (dates.error) {
            setIsRegistrationDateError(dates);
        } else {
            setTodayDate(dates.date);
        }
    };

    function addMonths(theDate: any, years: any) {
        return new Date(theDate.getTime() - years * 24 * 60 * 60 * 1000);
    }

    function subMonths(theDate: any, years: any) {
        return new Date(theDate.getTime() - years * 24 * 60 * 60 * 1000);
    }

    function onTodayDate(theDate: any, years: any) {
        return new Date(theDate.getTime() - years * 24 * 60 * 60 * 1000);
    }

    const handleDateofBirthChange = (e: any, type: any) => {
        const data = { ...studentsData.value };
        if (type === 'day') {
            setCanShowDate(e.target.value);
        } else if (type === 'month') {
            setCanShowMonth(e.target.value);
        } else if (type === 'year') {
            setCanShowYear(e.target.value);
        }
    }

    const onDateSelection = (value: any) => {
        setStartDate(null);
        if (value.error) {
            setIsDateError(value);
        } else {
            setStartDate(value.date);
        }

    }

    const onChangeName = (event: any) => {
        setNameError('');
        const reg = /^[A-Za-z]+(?:[ _-][A-Za-z]+)*$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setNameError('Enter only alphabets');
            } else {
                return true;
            }
        } else {
            setNameError('Please enter name');
        }
    }

    const onChangeAddressOne = (event: any) => {
        setAddressOneError('');
        if (event) {
            if (event.trim().length <= 2) {
                setAddressOneError('Address line 1 minimum 3 characters');
            } else if (event.trim().length >= 256) {
                setAddressOneError('Address line 1 maximum 256 characters');
            } else {
                return true;
            }
        } else {
            setAddressOneError('Please enter address line 1');
        }
    }

    const onChangeAddressTwo = (event: any) => {
        setAddressTwoError('');
        if (event) {
            if (event.trim().length <= 2) {
                setAddressTwoError('Address line 2 minimum 3 characters');
            } else if (event.trim().length >= 256) {
                setAddressTwoError('Address line 2 maximum 256 characters');
            } else {
                return true;
            }
        } else {
            setAddressTwoError('Please enter address line 2');
        }
    }

    const onChangeMotherName = (event: any) => {
        setMotherNameError('');
        const reg = /^[A-Za-z]+(?:[ _-][A-Za-z]+)*$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setMotherNameError('Enter only alphabets');
            } else {
                return true;
            }
        } else {
            setMotherNameError('Please enter Mother\'s name');
        }
    }

    const onChangeUserName = (event: any) => {
        const data = { ...studentsData.value };
        data.user_name = event;
        if (currentStudentData) {
            currentStudentData.user_name = event;
        }
        setUserNameError('');
        const reg = /^[a-zA-Z0-9._-]{6,15}$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setUserNameError('User name allow only a-z A-Z 0-9 ._-');
            } else {
                return true;
            }
        } else {
            setUserNameError('Please enter user name');
        }
    }

    const onChangePassword = (event: any) => {
        setPasswordError('');
        const reg = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setPasswordError('Password allow only a-z A-Z 0-9 !@#$%^&*()');
            } else {
                return true;
            }
        } else {
            setPasswordError('Please enter password');
        }
    }

    const onChangeMotherOccupation = (event: any) => {
        setMotherOccupationError('');
        const reg = /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setMotherOccupationError('Mother\'s occupation can`t contain spaces and special characters');
            } else {
                return true;
            }
        } else {
            setMotherOccupationError('Please enter Mother\'s occupation');
        }
    }

    const onChangeFatherName = (event: any) => {
        setFatherNameError('');
        const reg = /^[A-Za-z]+(?:[ _-][A-Za-z]+)*$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setFatherNameError('Enter only alphabets');
            } else {
                return true;
            }
        } else {
            setFatherNameError('Please enter Father\'s name');
        }
    }

    const onChangeFatherOccupation = (event: any) => {
        setFatherOccupationError('');
        const reg = /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/;
        if (event) {
            if (!reg.test(event.trim())) {
                setFatherOccupationError('Father\'s occupation can`t contain spaces and special characters');
            } else {
                return true;
            }
        } else {
            setFatherOccupationError('Please enter Father\'s occupation');
        }
    }

    const onChangeSchoolName = (event: any) => {
        setSchoolError('');
        if (event) {
            if (event.trim().length <= 2) {
                setSchoolError('School name minimum 3 characters');
            } else if (event.trim().length >= 256) {
                setSchoolError('School name maximum 256 characters');
            } else {
                return true;
            }
        } else {
            setSchoolError('Please enter school name');
        }
    }

    const onChangeSchoolAddress = (event: any) => {
        setSchoolAddressError('');
        if (event) {
            if (event.trim().length <= 2) {
                setSchoolAddressError('school address minimum 3 characters');
            } else if (event.trim().length >= 256) {
                setSchoolAddressError('school address maximum 256 characters');
            } else {
                return true;
            }
        } else {
            setSchoolAddressError('Please enter school address');
        }
    }

    const onChangeSchoolAddressTwo = (event: any) => {
        setSchoolAddressTwoError('');
        if (event) {
            if (event.trim().length <= 2) {
                setSchoolAddressTwoError('school address 2 minimum 3 characters');
            } else if (event.trim().length >= 256) {
                setSchoolAddressTwoError('school address 2 maximum 256 characters');
            } else {
                return true;
            }
        } else {
            setSchoolAddressTwoError('Please enter school address 2');
        }
    }

    const handleBloodGroupChange = (e: any) => {
        const data = { ...currentStudentData.value };
        data.blood_group = e.target.value;
        if (currentStudentData) {
            currentStudentData.blood_group = e.target.value;
        }
    }
    return (
        <div style={{ overflowY: "auto", height: "100vh" }}>
            <section className="d-flex justify-content-md-center align-items-center login-block-wraper">
                <div>
                    <div className={`modal fade ${canShowUserPopup ? 'show' : 'false'}`} style={{ display: (canShowUserPopup ? "block" : 'none') }} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Student Login Details</h5>
                                    <button type="button" className="close popup-close cursor-pointer" data-dismiss="modal" aria-label="Close" onClick={handleUserclose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div>Login ID: {studentInfo.user_name}</div>
                                    <div>Password: {studentInfo.password}</div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary cursor-pointer" data-dismiss="modal" onClick={handleUserclose}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white border border-gray rounded-16 p-3 p-lg-5 shadow-sm individual-user-block">
                        <div className="col-md-12 text-center">
                            <img src={LogoImg} alt="" className="login-logo" />
                        </div>
                        <div className="row justify-content-md-center login-row">
                            {loading &&
                                <div className="text-center p-5">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            }
                            {!loading && <div className="col-md-12">
                                <FormBuilder onUpdate={handleInput}>
                                    <form>
                                        <div className="row custom-form">
                                            <div style={{ borderBottom: 'solid 1px black', marginTop: '15px', paddingLeft: '10px' }} className="mb-4">
                                                <h5 className="form-label mb-2 d-block">Personal Details</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">
                                                        Student Name
                                                    </label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="name" onChange={(e) => onChangeName(e.target.value)} defaultValue={currentStudentData.name} placeholder="Please enter student name" />
                                                    {nameError && <p className="text-danger">{nameError}</p>}
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div>
                                                    <label className="form-label mb-4">Gender</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <br />
                                                    <input type="radio" name="gender" value="male" checked={currentStudentData?.gender === "male"} onChange={(e) => { handleGender(e) }} />
                                                    <span style={{ margin: '0px 12px' }}>Male</span>
                                                    <input type="radio" name="gender" value="female" checked={currentStudentData?.gender === "female"} onChange={(e) => { handleGender(e) }} />
                                                    <span style={{ margin: '0px 12px' }}>Female</span>

                                                    <input className="mb-0" type="radio" value="transgender" name="gender" checked={currentStudentData?.gender === "transgender"} onChange={(e) => { handleGender(e) }} />
                                                    <span style={{ paddingRight: '15px', paddingLeft: '15px' }}>Other</span>
                                                    {isFormSubmitted && !getInputValid('gender') && <p className="text-danger">Please select gender</p>}
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Date of Birth</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span><br />
                                                    {currentStudentData.date_of_birth &&
                                                        <DateComponent onDate={onDateSelection} yearDiff={18} defaultData={currentStudentData.date_of_birth}></DateComponent>}
                                                    {!currentStudentData.date_of_birth && <DateComponent onDate={onDateSelection} yearDiff={18}></DateComponent>}
                                                    {isFormSubmitted && !startDate && !isDateError?.error && <p className="text-danger">Please select date</p>}
                                                    {isDateError?.error && !startDate && <p className="text-danger">{isDateError?.error}</p>}

                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Blood Group</label>
                                                    <select name="blood_group" value={currentStudentData.blood_group} onChange={(e) => { handleBloodGroupChange(e) }} className="form-select form-select-lg mb-3">
                                                        <option value="">Select blood group</option>
                                                        <option value="O+">O+</option>
                                                        <option value="O-">O-</option>
                                                        <option value="A-">A-</option>
                                                        <option value="A+">A+</option>
                                                        <option value="B-">B-</option>
                                                        <option value="B+">B+</option>
                                                        <option value="AB-">AB-</option>
                                                        <option value="AB+">AB+</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Class</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <select className="form-select form-select-lg" name="standard" value={currentStudentData.standard} onChange={(e) => { handleStandardChange(e) }}>
                                                        <option value="">Select class</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                        <option value="11">11</option>
                                                        <option value="12">12</option>
                                                    </select>
                                                    {isFormSubmitted && !getInputValid('standard') && <p className="text-danger">Please select class</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Student Email ID</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="email_id" value={currentStudentData.email_id} onChange={(e) => { handleEmailChange(e) }} placeholder="Please enter email" />
                                                    {email && <p className="text-danger">{errorMessages.email}</p>}
                                                    {isFormSubmitted && !getInputValid('email_id') && <p className="text-danger">Please enter email id</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Confirm Student Email ID</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="confirm_student_email_id" value={currentStudentData.confirm_student_email_id} onChange={(e) => { handleConfirmEmailChange(e) }} placeholder="Please confirm email Id" />
                                                    {confirmEmail && <p className="text-danger">{errorMessages.email}</p>}
                                                    {isFormSubmitted && !getInputValid('confirm_student_email_id') && <p className="text-danger">Please enter confirm email id</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Student Mobile Number</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="mobile_number" maxLength={10} onChange={(e) => { handleMobileChange(e) }} value={currentStudentData.mobile_number} placeholder="Please enter mobile number" />
                                                    {mobileNumber && <p className="text-danger">{errorMessages.mobile_number}</p>}
                                                    {isFormSubmitted && !getInputValid('mobile_number') && <p className="text-danger">Please enter mobile number</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Confirm Student Mobile Number</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="confirm_student_mobile_number" maxLength={10} onChange={(e) => { handleConfirmMobileChange(e) }} value={currentStudentData.confirm_student_mobile_number} placeholder="Please enter confirm mobile  number" />
                                                    {confirmMobileNumber && <p className="text-danger">{errorMessages.mobile_number}</p>}
                                                    {isFormSubmitted && !getInputValid('confirm_student_mobile_number') && <p className="text-danger">Please enter confirm mobile number</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">User Name</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="user_name" onChange={(e) => onChangeUserName(e.target.value)} value={currentStudentData.user_name} placeholder="Please enter user name" />
                                                    {userNameError && <p className="text-danger">{userNameError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <span style={{ color: "blue", cursor: "pointer" }} onClick={checkAvalableNames}>Avalable User Names</span>
                                                </div>
                                                {avalableUserNames.map((user: any) => {
                                                    return <div style={{ marginRight: "10px" }}>
                                                        <input type="radio" name="user_name" value={user} checked={currentStudentData?.user_name === user} onChange={(e) => { handleUserName(e) }} />
                                                        <span style={{ margin: '0px 12px' }}>{user}</span>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Password</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="password" onChange={(e) => onChangePassword(e.target.value)} value={currentStudentData.password} placeholder="Please enter password" />
                                                    {passwordError && <p className="text-danger">{passwordError}</p>}
                                                </div>
                                            </div>
                                            <div style={{ borderBottom: 'solid 1px black', marginTop: '15px', paddingLeft: '10px' }} className="mb-4">
                                                <h5 className="form-label mb-2 d-block">Address</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Address Line 1</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="textarea" onChange={(e) => onChangeAddressOne(e.target.value)} value={currentStudentData?.address} name="address" placeholder="Please enter address line 1" />
                                                    {addressOne && <p className="text-danger">{addressOne}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Address Line 2 </label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="textarea" onChange={(e) => onChangeAddressTwo(e.target.value)} value={currentStudentData?.address2} name="address2" placeholder="Please enter address line 2" />
                                                    {addressTwo && <p className="text-danger">{addressTwo}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">State</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <select name="state" className="form-select form-select-lg" value={currentStudentData?.state} onChange={(e) => { handleStateChange(e) }}>
                                                        <option value="">Select state</option>
                                                        {statesData.map((name: any, i: number) => (
                                                            <option key={i} value={name.state}>
                                                                {name.state}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {isFormSubmitted && !getInputValid('state') && <p className="text-danger">Please select state</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">District</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <select name="district" className="form-select form-select-lg" value={currentStudentData?.district} onChange={(e) => { handleDistrictChange(e) }}>
                                                        <option value="">Select district</option>
                                                        {districtData.map((name: any, i: number) => (
                                                            <option key={i} value={name}>
                                                                {name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {isFormSubmitted && !getInputValid('district') && <p className="text-danger">Please select district</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">PIN Code</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="pin_code" maxLength={6} onChange={(e) => { handlePinCodeChange(e) }} value={currentStudentData?.pin_code} placeholder="Please enter PIN code" />
                                                    {pincodeNumber && <p className="text-danger">{errorMessages.pincode}</p>}
                                                    {isFormSubmitted && !getInputValid('pin_code') && <p className="text-danger">Please enter pin code</p>}
                                                </div>
                                            </div>

                                            <div style={{ borderBottom: 'solid 1px black', marginTop: '15px', paddingLeft: '10px' }} className="mb-4">
                                                <h5 className="form-label mb-2 d-block">Parents Details</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Mother's Name</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="mother_name" onChange={(e) => onChangeMotherName(e.target.value)} value={currentStudentData.mother_name} placeholder="Please enter mother's name" />
                                                    {motherNameError && <p className="text-danger">{motherNameError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Mother's Occupation</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="mother_occupation" onChange={(e) => onChangeMotherOccupation(e.target.value)} value={currentStudentData.mother_occupation} placeholder="Please enter mother's occupation" />
                                                    {motherOccupationError && <p className="text-danger">{motherOccupationError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Mother's Mobile Number</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="mother_mobile" maxLength={10} value={currentStudentData.mother_mobile} onChange={(e) => { handleMothesMobileChange(e) }} placeholder="Please enter mobile number" />
                                                    {motherMobileNumber && <p className="text-danger">{errorMessages.mobile_number}</p>}
                                                    {isFormSubmitted && !getInputValid('mother_mobile') && <p className="text-danger">Please enter mobile number</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Mother's WhatsApp Number</label>
                                                    (  <input type="checkbox" name="sameMobileNumber" checked={currentStudentData.checkedMother} onChange={(e) => { handleMotherMobileNumberChange(e) }} style={{ paddingLeft: '10px' }} />
                                                    <span style={{ paddingLeft: '10px' }}>Same as Mobile Number</span> )
                                                    <input className="form-control form-control-lg" disabled={currentStudentData.checkedMother} type="text" name="mother_whatsapp" maxLength={10} value={currentStudentData.mother_whatsapp} onChange={(e) => { handleMotherWhatsappChange(e) }} placeholder="Please enter whatsapp number" />
                                                    {(motherwhatsappNumber) && <p className="text-danger">{errorMessages.whatsapp_number}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Mother's Email ID</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="mother_email_id" value={currentStudentData.mother_email_id} onChange={(e) => { handleMotherEmailChange(e) }} placeholder="Please enter email Id" />
                                                    {motherEmail && <p className="text-danger">{errorMessages.email}</p>}
                                                    {isFormSubmitted && !getInputValid('mother_email_id') && <p className="text-danger">Please enter email id</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Father's Name</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="father_name" onChange={(e) => onChangeFatherName(e.target.value)} value={currentStudentData.father_name} placeholder="Please enter father's name" />
                                                    {fatherNameError && <p className="text-danger">{fatherNameError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Father's Occupation</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="father_occupation" onChange={(e) => onChangeFatherOccupation(e.target.value)} value={currentStudentData.father_occupation} placeholder="Please enter father's occupation" />
                                                    {fatherOccupationError && <p className="text-danger">{fatherOccupationError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Father's Mobile Number</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="father_mobile" maxLength={10} value={currentStudentData.father_mobile} onChange={(e) => { handleFatherMobileChange(e) }} placeholder="Please enter mobile number" />
                                                    {fathermobileNumber && <p className="text-danger">{errorMessages.mobile_number}</p>}
                                                    {isFormSubmitted && !getInputValid('father_mobile') && <p className="text-danger">Please enter mobile number</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Father's WhatsApp Number</label>
                                                    (  <input type="checkbox" name="sameMobileNumber" checked={currentStudentData.checkedFather} onChange={(e) => { handleFatherMobileNumberChange(e) }} style={{ paddingLeft: '10px' }} />
                                                    <span style={{ paddingLeft: '10px' }}>Same as Mobile Number</span> )
                                                    <input className="form-control form-control-lg" disabled={currentStudentData.checkedFather} type="text" name="father_whatsapp" maxLength={10} value={currentStudentData.father_whatsapp} onChange={(e) => { handleFatherWhatsappChange(e) }} placeholder="Please enter whatsapp number" />
                                                    {(fatherwhatsappNumber) && <p className="text-danger">{errorMessages.whatsapp_number}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Father's Email ID</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="father_email_id" value={currentStudentData.father_email_id} onChange={(e) => { handleFatherEmailChange(e) }} placeholder="Please enter email Id" />
                                                    {fatherEmail && <p className="text-danger">{errorMessages.email}</p>}
                                                    {isFormSubmitted && !getInputValid('father_email_id') && <p className="text-danger">Please enter email id</p>}
                                                </div>
                                            </div>
                                            <div style={{ borderBottom: 'solid 1px black', marginTop: '15px', paddingLeft: '10px' }} className="mb-4">
                                                <h5 className="form-label mb-2 d-block">School Details</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">School Name</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="textarea" value={currentStudentData?.institute_school_code} onChange={(e) => onChangeSchoolName(e.target.value)} name="institute_school_code" placeholder="Please enter school name" />
                                                    {schoolNameError && <p className="text-danger">{schoolNameError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">School Board</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <select className="form-select form-select-lg" name="school_board" value={currentStudentData?.school_board} onChange={(e) => { handleSchoolBoardChange(e) }}>
                                                        <option value="">Select school board</option>
                                                        <option value="SSC">SSC</option>
                                                        <option value="ICSE">ICSE</option>
                                                        <option value="CBSE">CBSE</option>
                                                    </select>
                                                    {isFormSubmitted && !getInputValid('school_board') && <p className="text-danger">Please select school board</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">State</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <select name="school_state" className="form-select form-select-lg" value={currentStudentData?.school_state} onChange={(e) => { handleSchoolStateChange(e) }}>
                                                        <option value="">Select state</option>
                                                        {statesData.map((name: any, i: number) => (
                                                            <option key={i} value={name.state}>
                                                                {name.state}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {isFormSubmitted && !getInputValid('school_state') && <p className="text-danger">Please select state</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">District</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <select name="school_district" className="form-select form-select-lg" value={currentStudentData?.school_district} onChange={(e) => { handleSchoolDistrictChange(e) }}>
                                                        <option value="">Select district</option>
                                                        {districtData.map((name: any, i: number) => (
                                                            <option key={i} value={name}>
                                                                {name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {isFormSubmitted && !getInputValid('school_district') && <p className="text-danger">Please select district</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Address Line 1</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="textarea" value={currentStudentData?.school_address} onChange={(e) => onChangeSchoolAddress(e.target.value)} name="school_address" placeholder="Please enter address line 1" />
                                                    {schoolAddressError && <p className="text-danger">{schoolAddressError}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">Address Line 2</label>
                                                    <input className="form-control form-control-lg" type="textarea" value={currentStudentData?.school_address2} name="school_address2" placeholder="Please enter address line 2" />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-4">
                                                    <label className="form-label mb-0">PIN Code</label>
                                                    <span style={{ color: 'red', fontSize: '22px', paddingLeft: '10px' }}>*</span>
                                                    <input className="form-control form-control-lg" type="text" name="school_pincode" maxLength={6} onChange={(e) => { handleSchoolPinCodeChange(e) }} value={currentStudentData?.school_pincode} placeholder="Please enter PIN code" />
                                                    {pincodeNumber && <p className="text-danger">{errorMessages.pincode}</p>}
                                                    {isFormSubmitted && !getInputValid('school_pincode') && <p className="text-danger">Please enter pin code</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </FormBuilder>
                                <div className="form-footer border-top border-primary py-3 text-end mt-4">
                                    <a className="btn btn-primary btn-sm px-5 rounded-12 cursor-pointer" onClick={handleSubmit}>Create</a>
                                    <Link className="text-dark text-decoration-none ms-2 cursor-pointer" to={`/`}>Cancel</Link>
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div className="login-elements text-center" style={{ marginTop: '2rem', marginBottom: '1rem' }}>
                        <img src={Logos} alt="" className="login-elements-icons individual-user-login-icons" /></div>
                </div>
            </section >
            <footer className="text-center f12 text-dgray">
                <div className="container">
                    &copy; 2023-24  <a href="http://iamsamarth.com" className="text-dgray text-decoration-none">iamsamarth.com</a>. All Rights Reserved | <a href="http://iamsamarth.com/privacy-policy/" className="text-dgray text-decoration-none">Terms and Conditions</a> |
                    <a href="http://iamsamarth.com/privacy-policy/" className="text-dgray text-decoration-none ms-1">Privacy Policy</a>
                </div>
            </footer>
        </div >
    )
}